import React, { useEffect, useState } from 'react';
import GlobalHeader from '../../../GlobalHeader/GlobalHeader';
import SubNavigationBar from '../../../GlobalHeader/SubNavigationBar';
import GlobalFooter from '../../../GlobalHeader/GlobalFooter';
import SidebarMenu from '../../TraderDashboard/SidebarMenu';
import RightPanel from '../../TraderDashboard/RightPanel';


export default function DashboardLayout({ children }) {
  const [theme, setTheme] = useState(() =>
    localStorage.getItem('theme') || 'dark'
  );

  useEffect(() => {
    const root = window.document.documentElement;
    if (theme === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
    localStorage.setItem('theme', theme);
  }, [theme]);

  return (
    <div className="flex flex-col h-screen overflow-hidden bg-gray-100 dark:bg-gray-900 relative text-gray-900 dark:text-white">

      {/* ====== TOP NAVIGATION ====== */}
      <div className="shrink-0 relative">
        <GlobalHeader />
        <SubNavigationBar />
        
      </div>

      {/* ====== 3-COLUMN FLEX LAYOUT ====== */}
      <div className="flex flex-1 overflow-hidden px-2 gap-2">
        {/* LEFT SIDEBAR */}
        <div className="w-60 shrink-0 overflow-y-auto">
          <SidebarMenu user={{ name: 'Senthil Kumar' }} roles={['Freelancer', 'Investor']} />
        </div>

        {/* MAIN CONTENT AREA */}
        <main className="flex-1 overflow-y-auto bg-white dark:bg-gray-800 p-4 rounded">
          {children}
        </main>

        {/* RIGHT SIDEBAR */}
        <div className="w-80 shrink-0 overflow-y-auto hidden lg:block">
          <RightPanel />
        </div>
      </div>

      {/* ====== AUTO-HIDE FOOTER DOCK ====== */}
      <div className="relative">
        <div className="fixed bottom-0 left-0 w-full h-[12px] z-40 group">
          <div
            className={`
              absolute bottom-0 left-0 w-full
              transform transition-all duration-300 ease-in-out
              translate-y-full opacity-0
              group-hover:translate-y-0 group-hover:opacity-100
            `}
          >
            <GlobalFooter />
          </div>
        </div>
      </div>
    </div>
  );
}
